import { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from '../../Helper/Api/axios.instance';
import { AppConfig } from '../../Config/app-config';
import { MissionNameEnum } from '../../types/enums/missionName.enum';
import { useUserContext } from '../../context/user.context';
import { QuestNameEnum } from '../../types/enums/questName.enum';
import { QuestType } from '../../types/quest.type';
import { MissionType } from '../../types/mission.type';
import { useTwitterMission } from './useTwitterMission';

export const useAirdropMissions = () => {
  const { isLoggedIn, profileData } = useUserContext();
  const [multipliers, setMultipliers] = useState<MissionType[]>([]);
  const [quests, setQuests] = useState<QuestType[]>([]);

  const { twitterConnected, twitterLogin } = useTwitterMission();

  const telegramLogin = useCallback(async () => {
    const telegramUrl = new URL(
      `https://t.me/${AppConfig.telegramBotName}?start=${profileData.publicId}`,
    );

    const a = document.createElement('a');
    a.href = telegramUrl.toString();
    a.target = '_blank';
    a.click();
    a.remove();
  }, [profileData?.publicId]);

  const fetchMultipliers = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get<MissionType[]>(
        AppConfig.apiRoutes.listMissions(),
      );

      setMultipliers(
        data.filter((multiplier) =>
          Object.values(MissionNameEnum).includes(multiplier.name),
        ) || [],
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  const fetchQuests = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get<QuestType[]>(
        AppConfig.apiRoutes.listQuests(),
      );

      setQuests(
        data.filter((quest) =>
          Object.values(QuestNameEnum).includes(quest.name),
        ) || [],
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    void fetchMultipliers();
    void fetchQuests();
  }, [twitterConnected, isLoggedIn, fetchMultipliers, fetchQuests]);

  return {
    multipliers,
    quests,
    twitter: {
      twitterLogin,
    },
    telegram: {
      telegramLogin,
    },
  };
};
